import React from 'react';
import {
  IonButton,
  IonInput,
  IonItem,
  IonLabel,
  IonSelect,
  IonSelectOption,
  IonList,
  IonText,
  IonCard,
  IonCardContent,
} from '@ionic/react';

const AmountFilter = ({ minAmount, maxAmount, handleChangeAmount, component, error }) => {
  const formattedMinAmount = minAmount ? minAmount : '';
  const formattedMaxAmount = maxAmount ? maxAmount : '';

  return (
    <IonCard>
      <IonCardContent>
        <IonLabel>
          <IonText color="dark">
            <h6>{component === 'tenants' ? 'Account Balance' : 'Amount'}</h6>
          </IonText>
        </IonLabel>
      </IonCardContent>

      <IonItem>
        <IonInput
          name={component === 'tenants' ? 'minBalance' : 'minAmount'}
          placeholder="min"
          value={formattedMinAmount}
          onIonChange={(e) => handleChangeAmount(e)}
        ></IonInput>
        <IonInput
          name={component === 'tenants' ? 'maxBalance' : 'maxAmount'}
          placeholder="max"
          value={formattedMaxAmount}
          onIonChange={(e) => handleChangeAmount(e)}
        ></IonInput>
      </IonItem>
    </IonCard>
  );
};

export default AmountFilter;